module.exports = __webpack_public_path__ + "img/70.067104cc.jpg";